import React, { Component } from "react";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Environment from "../../utils/Environement";
import { shortenUUID } from "../../utils/formater";

interface PropsInterface {
  restaurant: PopinaRestaurant;
}

class PaymentMethodsTableComponent extends Component<PropsInterface> {
  constructor(props: PropsInterface) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    return (
      <div style={{ width: "80%", margin: "auto", padding: "20px 0" }}>
        {this.props.restaurant.paymentMethods.map((paymentMethod, i) => (
          <div
            key={paymentMethod?.client_id}
            style={{
              border: Environment.isPopina
                ? "1px solid #cee2d8"
                : "1px solid #f4e7b9",
              borderRadius: "3px",
              backgroundColor: "#f1f1f5",
              margin: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                padding: "15px 20px",
                justifyContent: "space-between",
                maxWidth: "1000px",
                margin:'auto'
              }}
            >
              <div
                style={{
                  fontSize: "17px",
                  color: "#474F5E",
                  alignItems: "center",
                  display: "flex",
                  visibility: "visible",
                  width: "30%"
                }}
              >
                {paymentMethod.name}
                <span
                  style={{
                    color: "#33499ac2",
                    margin: 0,
                    fontWeight: "bold",
                    marginLeft: "2px"
                  }}
                >
                  ({shortenUUID(paymentMethod?.client_id)})
                </span>
              </div>
              <p
                style={{
                  color: paymentMethod.enabled ? "#7abf92" : "#cc0000",
                  margin: 0,
                  fontWeight: "bold"
                }}
              >
                {paymentMethod.enabled ? "Activé" : "Désactivé"}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default PaymentMethodsTableComponent;
